import React from "react";
import { Dialog } from "@mui/material";
import "./PrimaryLoader.css";

const modalStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};

const contentStyle = {
    backgroundColor: "transparent",
    border: "none",
    padding: "20px",
    height: "500px",
    width: "500px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};


const PrimaryLoader = ({ openModal }) => {
    return (
        <Dialog
            open={openModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            style={modalStyle}
            PaperProps={{
                style: {
                    backgroundColor: "transparent",
                    boxShadow: "none",
                },
            }}
            disableScrollLock={true}
        >
            <div style={contentStyle}>
                <div className="loader"></div>
            </div>
        </Dialog>
    );
};

export default PrimaryLoader;
